var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"drop",style:('top:'+_vm.top+'%;left:'+_vm.left+'%'),attrs:{"src":'/'+_vm.$home+'graf/tropfen.svg',"width":_vm.size,"height":_vm.size*1.3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }